module.exports = __webpack_public_path__ + "static/media/presion-02.f89158d5.jpg";